import { useState } from "react";
import * as React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/VBM_LOGO_FULL.png";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import UploadIcon from '@mui/icons-material/FileUpload';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { createTheme } from '@mui/material/styles';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import { useEffect } from "react";
import ModuleMenu from "../../components/ModuleMenu";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));

const availableModules = [
  { label: "Patching", route: "/patching/dashboard" },
  { label: "Space Allocation", route: "/main/spaceallocationdashboard" },
  { label: "Tray Import", route: "/main/trayimportdashboard" },
  { label: "User Management", route: "/hr/usersdashboard" },
  { label: "Inventory", route: "/main/inventorydashboard" },
  { label: "Growing", route: "/main/growingdashboard" },
  { label: "Logistics", route: "/logistics/dashboard" },
  { label: "Invoicing", route: "/invoicing/dashboard" },
  { label: "Shipping", route: "/shipping/dashboard" },
  { label: "Purchase Orders", route: "/po/podashboard" },
];
export default function TrayImportDashboard() {

  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Tray Import Dashboard",
      backgroundPath: "/assets/images/inventorybg.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };


  const [errorMessage, setErrorMessage] = useState({ error: "" });
  const [value, setValue] = React.useState<any | null>(availableModules[0]);
  let items = [];
  let history = useNavigate();

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#999" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));


  const moduleChanged = (event: any, newValue: any | null) => {
    console.log(newValue);
    navigate(newValue.route);
  };

  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <section className="loginArea">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={5}
        >
          <img src={Logo} height="125px" />
        </Box>
        <Box display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={6}><Typography variant="h3">Tray Import Dashboard</Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={4}
          marginBottom={8}
        >
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 700,
              boxShadow: 12,
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={availableModules}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Select a Module" />}
              onChange={(e, newValue) => { moduleChanged(e, newValue) }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton sx={{ p: "10px" }} aria-label="menu" onClick={handleClickOpen}>
              <MenuIcon />
            </IconButton>
          </Paper>
        </Box>

        <Box sx={{ flexGrow: 1, mt: 3 }}>
          <Grid container spacing={1} sx={{ padding: 2 }}>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12,border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<UploadIcon sx={{ width: 55, height: 55, color:"#89B219" }} />}
                  onClick={() => navigate("/patching/tray-import")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>TRAY IMPORT</Typography>
                </Button>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </section>
      <div>
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                            maxWidth='xl'
                            fullWidth
                        >
                            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                                VBM Modules
                            </BootstrapDialogTitle>
                            <DialogContent dividers>
                            <ModuleMenu></ModuleMenu>
                            </DialogContent>
                        </BootstrapDialog>
                    </div>
    </div>

    
  );
}
